<app-table
  [lazy]="true"
  [cols]="columns"
  tableTitle="Transações não exportadas para Bfluence"
  [addButton]="false"
  [exportPdf]="false"
  [exportExcel]="false"
  [extraButton]="true"
  (extraButtonClick)="syncTableElements()"
  extraLabel="Sincronizar Tabela"
  [service]="bfluenceIntegrityService"
  pageFunctionName="getUncomputedBfluenceTransactionCheckTable"
  emptyMessage="Sem mais transações pendentes no momento."
  selectionActionLabel="Corrigir"
  selectionActionTooltip="Marcar como resolvido"
  selectionActionIcon="pi pi-check"
  (emitSelection)="markAsResolved($event)"
  modelName="registros"
  [defaultRows]="10"
></app-table>
<p-confirmDialog></p-confirmDialog>
<p-toast></p-toast>
